export enum FamilyProfileOwnership {
  Me = 'me',
  TransferRequest = 'transfer_request',
  AcceptRequest = 'accept_request',
  FromClinic = 'from_clinic',
  Transferred = 'transferred',
  Refused = 'refused',
  Accepted = 'accepted',
  Shared = 'shared'
}
